import styled from "styled-components";
import { baseStyle } from "../styles";

export const Subtitle = styled.p`
  ${baseStyle};
  color: ${({ theme }) => theme.text.color.subtitle};
`;
